import { TYPES_DOCUMENTOS } from "features/Crear/pages/FormCreacionDocumento/constant"
import { DocumentosActionLabel, getDocumentosActionLabel } from "../templates"

export const TAB_DOCUMENTOS_RECIBIDOS = "TAB_DOCUMENTOS_RECIBIDOS"

export const ESTADO_COLUMN = "ESTADO_COLUMN"

export const ESTADOS_SIN_CESION = "estadoCesion"

export const ESTADO_CESION = "cesionStatus"

export const TIPOS_DOCUMENTO = {
  0: "Compra",
  1: "Venta",
}

// @ts-expect-error TS(7030): Not all code paths return a value.
export const typeDocument = (pathname: $TSMigrationFixMe) => {
  switch (pathname) {
    case "presupuestos":
      return 25
    case "pedidos":
      return 24
    case "albaranes":
      return 18
    case "facturas":
      return 15
    default:
      break
  }
}

export const classesToExclude = [
  "actionsPresupuesto",
  "archivosAdjuntos",
  "estadoRevisionActual",
  "p-connected-overlay-enter-done",
  "p-dropdown-label",
  "text-button-convertir",
  "p-dropdown-item",
  "p-dropdown-trigger",
  "icon-convertir",
  "button-convertir",
  "convertirTemplate",
]

export const showModalIfNecessary = (e: $TSMigrationFixMe) => {
  return !classesToExclude.some((className) =>
    (e.originalEvent ?? e).target.classList.contains(className)
  )
}

export const isPage = (typeDocumentTable: $TSMigrationFixMe, page = "") => {
  // return window.location.pathname.includes(`/documentos/${page}`)
  // return window.location.pathname.includes("/contactos/")
  return typeDocumentTable === page
}

export const actionHasSubmenu = (
  typeDocumentTable: $TSMigrationFixMe,
  isVenta = true
) =>
  isPage(typeDocumentTable, "presupuestos") ||
  (isPage(typeDocumentTable, "pedidos") && isVenta)

export const getDocumentoActionSubItems = (
  t: $TSMigrationFixMe,
  isDocumentoVenta: $TSMigrationFixMe,
  onConvertDocument: $TSMigrationFixMe,
  typeDocumentTable: $TSMigrationFixMe
) => {
  return [
    ...(isPage(typeDocumentTable, "presupuestos")
      ? [
          {
            icon: "file-lines",
            label: getDocumentosActionLabel(
              `${t("crear.presupuesto.convertLabel")} ${t(
                "crear.presupuesto.tab.orderLabel"
              )}`,
              "file-lines"
            ),
            command: (e: $TSMigrationFixMe) =>
              onConvertDocument(e, TYPES_DOCUMENTOS.PEDIDO),
          },
        ]
      : []),
    ...(isPage(typeDocumentTable, "presupuestos") ||
    (isPage(typeDocumentTable, "pedidos") && isDocumentoVenta)
      ? [
          {
            icon: "file-contract",
            label: getDocumentosActionLabel(
              `${t("crear.presupuesto.convertLabel")} ${t(
                "crear.presupuesto.tab.deliveryLabel"
              )}`,
              "file-contract"
            ),
            command: (e: $TSMigrationFixMe) =>
              onConvertDocument(e, TYPES_DOCUMENTOS.ALBARAN),
          },
        ]
      : []),
    ...((isPage(typeDocumentTable, "presupuestos") ||
      isPage(typeDocumentTable, "pedidos")) &&
    isDocumentoVenta
      ? [
          {
            icon: "file-invoice",
            label: getDocumentosActionLabel(
              `${t("crear.presupuesto.convertLabel")} ${t(
                "crear.presupuesto.tab.invoceLabel"
              )}`,
              "file-invoice"
            ),
            command: (e: $TSMigrationFixMe) =>
              onConvertDocument(e, TYPES_DOCUMENTOS.FACTURA),
          },
        ]
      : []),
  ]
}

export const getDocumentoActions = (
  t: $TSMigrationFixMe,
  typeDocumentTable: $TSMigrationFixMe,
  isDocumentoVenta: $TSMigrationFixMe,
  onDownloadDocument: $TSMigrationFixMe,
  onConvertDocument: $TSMigrationFixMe
) => {
  return [
    {
      icon: "arrow-down-to-bracket",
      label: (
        <DocumentosActionLabel
          icon={["fal", "arrow-down-to-bracket"]}
          className='mx-2 icon-convertir-xl'
          description={t("crear.presupuesto.modal.msg.downloadTypes")}
          title={t("crear.presupuesto.tab.downloadLabel")}
        />
      ),
      command: onDownloadDocument,
    },
    ...(actionHasSubmenu(typeDocumentTable, isDocumentoVenta)
      ? [
          {
            icon: "file-lines",
            label: (
              <DocumentosActionLabel
                icon={["fal", "file-lines"]}
                className='mx-2 icon-convertir-xl'
                title={t("crear.presupuesto.tab.convertirLabel")}
              />
            ),
            command: (e: $TSMigrationFixMe) =>
              e.originalEvent.stopPropagation(),
            items: getDocumentoActionSubItems(
              t,
              isDocumentoVenta,
              onConvertDocument,
              typeDocumentTable
            ),
          },
        ]
      : []),
    ...((isPage(typeDocumentTable, "pedidos") && !isDocumentoVenta) ||
    (isPage(typeDocumentTable, "albaranes") && isDocumentoVenta)
      ? [
          {
            icon: "file-contract",
            label: (
              <DocumentosActionLabel
                icon={["fal", "file-contract"]}
                className='mx-2 icon-convertir-xl'
                title={t(
                  `crear.presupuesto.tab.${
                    isPage(typeDocumentTable, "albaranes")
                      ? "convertInvLabel"
                      : "convertDelLabel"
                  }`
                )}
              />
            ),
            command: (e: $TSMigrationFixMe) =>
              onConvertDocument(
                e,
                isPage(typeDocumentTable, "albaranes") ? "factura" : "albaran",
                false
              ),
          },
        ]
      : []),
  ]
}
